import { Fragment } from "react";

interface Props {
  tokens?: (string | undefined)[];
}

export const MultiLineText = ({ tokens }: Props) =>
  tokens ? (
    <>
      {tokens
        .filter((token): token is string => !!token && token.length > 0)
        .map((token, index) => (
          <Fragment key={token}>
            {token}
            {index < tokens.length - 1 ? <br /> : undefined}
          </Fragment>
        ))}
    </>
  ) : null;
